import React from "react";
import PageShell from "../common/page_shell";
import Projects from "../inner/project/projects";
import data from "../data/biodata.json";

const ProjectsPage = () => {
  return (
    <PageShell>
      <Projects projectList={data?.details?.project_details || {}} />
    </PageShell>
  );
};

export default ProjectsPage;
